<template>
  <div class="flex_center">
    1321
  </div>
</template>

<script>
	export default {
		name: "Video"
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Main/Video/Video.vue